import React, { useState, useEffect } from 'react';
import { solutions } from '../data/solutions';
import Breadcrumbs from '../components/Breadcrumbs';
import '../styles/Solutions.css';

const groupBy = (items, key) => items.reduce((map, item) => {
  const k = item[key] || 'Other';
  if (!map[k]) map[k] = [];
  map[k].push(item);
  return map;
}, {});

const SolutionsIndexPage = () => {
  const getUrlParams = () => {
    if (typeof window === 'undefined') return {};
    const urlParams = new URLSearchParams(window.location.search);
    return {
      category: urlParams.get('category') || 'All'
    };
  };

  const [selectedCategory, setSelectedCategory] = useState(getUrlParams().category);

  useEffect(() => {
    console.log('SolutionsIndexPage mounted');
    const params = getUrlParams();
    if (params.category !== selectedCategory) {
      setSelectedCategory(params.category);
    }
    return () => {
      console.log('SolutionsIndexPage unmounted');
    };
  }, [selectedCategory]);
  const groups = groupBy(solutions, 'category');
  
  const categories = [
    'All',
    'Fire Systems',
    'Communication Systems', 
    'Power Solutions',
    'Automation Solutions',
    'Facility Management',
    'Security Systems',
    'Data Centers',
    'Networking Solutions',
  ];

  const filteredSolutions = selectedCategory === 'All' 
    ? solutions 
    : groups[selectedCategory] || [];

  return (
    <div className="solutions-index">
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Solutions' }]} />
      
      <div className="solutions-layout">
        <div className="categories-sidebar">
          <h3 className="categories-title">| CATEGORIES</h3>
          <ul className="categories-list">
            {categories.map((category) => (
              <li key={category} className="category-item">
                <button 
                  className={`category-button ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => {
                    setSelectedCategory(category);
                    const newUrl = category === 'All' 
                      ? '/solutions/' 
                      : `/solutions/?category=${encodeURIComponent(category)}`;
                    window.history.pushState({}, '', newUrl);
                  }}
                >
                  {category}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="solutions-main">
          <div className="solutions-grid">
            {filteredSolutions.map((solution) => (
              <div key={solution.slug} className="solution-card">
                <a href={`/solutions/${solution.slug}`} className="solution-card-link">
                  <div className="solution-image">
                    <img 
                      src={solution.image} 
                      alt={solution.title}
                    />
                  </div>
                  <div className="solution-content">
                    <h3 className="solution-title">{solution.title}</h3>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default SolutionsIndexPage;




